import * as React from "react";
import { FormEvent, useMemo } from "react";
import {
	CommonFormContainer,
	CommonFormDescription,
	CommonFormRightSide,
	CommonFormSocial,
} from "../../Modals/CommonSignForm/CommonSignForm.styled";
import { Button, InputField } from "../../../common";
import { ButtonTheme, NOTIFICATION_TYPE } from "../../../../constants";
import {
	SignUpDescription,
	SignUpFormContainer,
	SignUpRightSideFooter,
} from "../../Modals/SignUpModal/SignUpModal.styled";
import { useStores } from "../../../../stores";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { gtmEvent } from "../../../../helpers";
import { AuthSchema } from "../../../../validation-schems";
import { FacebookClientResponsive } from "../../../../response";

import { AuthSignUpRequest } from "../../../../requests";
import { useTranslation } from "react-i18next";
import { Description, Title } from "../../../../pages/ContactPage/ContactPage.styled";
import { createDeferredValidationHandlers } from "../../../../helpers/formik";

interface SignIUpFormProps {}

export const SignUpForm = ({}: SignIUpFormProps) => {
	const { t } = useTranslation();

	const { authStore, notificationsStore, geoPluginStore } = useStores();
	const navigate = useNavigate();

	const formik = useFormik({
		validateOnBlur: true,
		validateOnChange: false,
		initialValues: {
			email: "",
		},
		validationSchema: AuthSchema,
		onSubmit: async (values) => {
			try {
				await authStore.signUp(values as AuthSignUpRequest);

				gtmEvent({ event: "Sign_Up", email: values.email.toLowerCase() });

				// Уведомление
				// authStore.setCongratulationsEmail(values.email);
				// authStore.congratulationsModal.open();

				// Очищаем форму
				formik.resetForm();
			} catch (e: any) {
				notificationsStore.add({
					type: NOTIFICATION_TYPE.ERROR,
					title: "Error",
					message: e.errors.join("<br/>"),
				});
			}
		},
	});

	const handleOnSignIn = (e: FormEvent) => {
		e.preventDefault();
		navigate("/sign/login");
	};

	const handleOnFacebook = async (data: FacebookClientResponsive) => {
		try {
			await authStore.signFacebook(data);
			authStore.signInForm.modal.close();
			navigate("/cabinet/my-subscriptions");

			notificationsStore.add({
				title: "Success",
			});
		} catch {}
	};

	const handleOnGoogle = async (data: any) => {
		try {
			await authStore.signGoogle({
				access_token: data.accessToken,
				email: data.profileObj.email,
				first_name: data.profileObj.givenName,
				last_name: data.profileObj.familyName,
				picture: data.profileObj.imageUrl,
			});
			authStore.signInForm.modal.close();
			navigate("/cabinet/my-subscriptions");

			gtmEvent({ event: "Sign_up", email: data.profileObj.email.toLowerCase() });
		} catch {}
	};

	const emailField = useMemo(() => createDeferredValidationHandlers(formik, "email"), [formik]);

	return (
		<>
			<Title dangerouslySetInnerHTML={{ __html: t("pages.sign.up.title") }} />
			<div style={{ height: 30 }} />
			<Description
				dangerouslySetInnerHTML={{
					__html: t("pages.sign.description"),
				}}
			></Description>

			<CommonFormContainer onlyForm>
				<CommonFormRightSide>
					<CommonFormSocial></CommonFormSocial>

					<SignUpFormContainer onSubmit={formik.handleSubmit}>
						<InputField
							type={"email"}
							name={"email"}
							value={formik.values.email}
							placeholder={"Your email"}
							errorMessage={emailField.getError()}
							onChange={emailField.handleChange}
							onBlur={emailField.handleBlur}
						/>

						<SignUpDescription style={{ height: "60px" }}>{t("pages.sign.up.description_form")}</SignUpDescription>

						<Button type={"submit"} disabled={formik.errors.email !== undefined || authStore.signUpForm.isLoading}>
							{t("buttons.sign_up")}
						</Button>
					</SignUpFormContainer>

					<SignUpRightSideFooter>
						<CommonFormDescription>{t("messages.exist_account")}</CommonFormDescription>
						<Button theme={ButtonTheme.LINK_LARGE} onClick={handleOnSignIn}>
							{t("buttons.sign_in")}
						</Button>
					</SignUpRightSideFooter>
				</CommonFormRightSide>
			</CommonFormContainer>
		</>
	);
};
